import * as React from "react"
import { Heading, Stack, Flex, Box } from "@chakra-ui/react"
import { HomeDescriptionProps } from "./home.interface"
import Countdown from "react-countdown"
import { convertDateStringToISO  } from "../../../util"
import { roomSelector } from "../../../recoil/atoms/room"
import { useRecoilValue, useRecoilState } from "recoil"
import layoutStates from "../../../recoil/atoms/layout"
import { ConsoleLogger } from "../../../util/logger"
import useConfig from "src/hooks/useConfig"

const logger = new ConsoleLogger()

const _HomeDescription: React.FC<HomeDescriptionProps> = ({
  showMinifiedLables,
  roomStyles,
  isLandscape,
  isSmallWidth
}) => {
  const {hidePersonalRoomTitle} = useConfig()
  const room = useRecoilValue(roomSelector)
  const [showHeader] = useRecoilState(layoutStates.showHeader)
  const renderer = ({ hours, minutes, seconds, completed, days }) => {
    const array = [
      { text: "Days", data: days },
      { text: "Hours", data: hours },
      { text: "Min", data: minutes },
      { text: "Sec", data: seconds }
    ]

    if (completed) {
      return null
    } else {
      return (
        <Box>
          {array.map(item => (
            <Box
              as="span"
              display="inline-block"
              color={roomStyles?.joinPagePanelSubTextColor ?? "inherit"}
            >
              <Flex
                flexDirection="column"
                margin={isSmallWidth || isLandscape ? "0px" : "0 5px"}
                width={isSmallWidth || isLandscape ? "50px" : "65px"}
                flexWrap="nowrap"
                alignItems={"center"}
                justifyContent="center"
              >
                <Flex
                  width={isSmallWidth || isLandscape ? "50px" : "65px"}
                  maxHeight="50px"
                  fontWeight="700"
                  fontSize={isSmallWidth || isLandscape ? "30px" : "40px"}
                  lineHeight={1}
                  textAlign="center"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.data}
                </Flex>
                <Flex
                  width={isSmallWidth || isLandscape ? "50px" : "65px"}
                  textAlign="center"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.text}
                </Flex>
              </Flex>
            </Box>
          ))}
        </Box>
      )
    }
  }
  
  const time = React.useMemo(() => {
    if (!room) return
    if ( room.countdownTimeUTC ) {
      try{
        const dateString = new Date(convertDateStringToISO(room.countdownTimeUTC))
        logger.log("CountDownTime: ", dateString)
        return dateString
      } catch (error) {
        return null
      }
    }
    return null
  }, [room?.countdownTimeUTC])

  const hide = !room?.enableCountdownTimer && hidePersonalRoomTitle
  if (hide) return null

  return (
    <Stack
      align={"center"}
      marginTop={isLandscape && !showHeader && "0.3rem !important"}
      marginBottom={isLandscape && !showHeader && "3px !important"}
    >
      {hidePersonalRoomTitle && room?.name != "Personal room" && (
        <Heading
          fontSize={isLandscape ? "2xl" : "4xl"}
          align={"center"}
          color={roomStyles?.joinPagePanelTextColor ?? "#000000"}
        >
          {room?.name}
        </Heading>
      )}
      {room && room.enableCountdownTimer && time && (
        <Countdown date={time} renderer={renderer} />
      )}
    </Stack>
  )
}

export const HomeDescription = React.memo(_HomeDescription)
